exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[disabled=disabled][data-v-eb8ad26a]{opacity:.4;cursor:auto}", ""]);

// exports
